/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ClientPolicyDto } from '../models/ClientPolicyDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ClientPolicyService {
    /**
     * Get all client policy configurations
     * @returns ClientPolicyDto
     * @throws ApiError
     */
    public static clientConfigControllerGetAllClientPoliciesV1(): CancelablePromise<Array<ClientPolicyDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/policy',
        });
    }
    /**
     * Update client policy configuration
     * @param requestBody
     * @returns ClientPolicyDto
     * @throws ApiError
     */
    public static clientConfigControllerUpdateClientPolicyV1(
        requestBody: ClientPolicyDto,
    ): CancelablePromise<ClientPolicyDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/v1/policy',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get client policy configuration for a specific platform
     * @param platform Platform identifier (ios, android)
     * @returns ClientPolicyDto
     * @throws ApiError
     */
    public static clientConfigControllerGetClientPolicyByPlatformV1(
        platform: 'ios' | 'android' | 'web' | 'electron',
    ): CancelablePromise<ClientPolicyDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/policy/{platform}',
            path: {
                'platform': platform,
            },
        });
    }
}
